import { FC, useMemo } from "react";
import { CampaignType } from "@vviinn/user-managment-client-ts";

import { NamedSelect } from "../../../ui/layout/molecules/NamedSelect";
import { Preset } from "../types";
import { campaignPresets } from "../constants";
import { useAppSelector } from "../../../store";

import { StateAction } from "../../../helpers/functions/types";
import { campaignTypes } from "../../constants";
import { NamedRadio } from "../../../ui/layout/molecules/NamedRadio";

export const CampaignPreset: FC<
  {
    campaignType: CampaignType;
    setShowAdvancedSettings: StateAction<boolean>;
  } & Preset
> = ({
  campaignType,
  campaignPreset,
  onPresetChange,
  referenceCampaignId,
  setReferenceCampaignId,
}) => {
  const existingCampaigns = useAppSelector(
    (state) => state.campaigns.campaigns,
  );

  const campaignByTypes = useMemo(
    () =>
      Object.fromEntries(
        campaignTypes.map((campaignType) => [
          campaignType,
          existingCampaigns
            .filter(({ type }) => type === campaignType)
            .map(({ id, name }) => ({ value: id, title: name })),
        ]),
      ),
    [existingCampaigns],
  );

  const referencesExist = useMemo(
    () => !!campaignByTypes[campaignType].length,
    [campaignByTypes, campaignType],
  );

  return (
    <>
      <NamedRadio
        title="Configuration"
        value={campaignPreset}
        customId="preset"
        options={Object.entries(campaignPresets).map(([value, title]) => ({
          value,
          title,
          disabled: value === "copy" && !campaignByTypes[campaignType].length,
          selected: value === campaignPreset,
        }))}
        onChange={(value) => {
          onPresetChange(value);
          setReferenceCampaignId(
            value === "copy" && referencesExist
              ? campaignByTypes[campaignType][0].value
              : undefined,
          );
        }}
        disabledMessage="Current site doesn't have campaigns of this type yet"
      />
      {campaignPreset === "copy" && referencesExist && (
        <NamedSelect
          styleVariant="newPage"
          title="Reference campaign"
          required={true}
          value={referenceCampaignId}
          options={campaignByTypes[campaignType]}
          onChange={({ value }) => setReferenceCampaignId(value)}
        />
      )}
    </>
  );
};
